import { categoryNameToHandle } from '@lambda/reebelo/src/commonHelpers';

export const generateCategoryPageUrl = (
  categoryName: string,
  categoryPk: string,
) => {
  const categoryHandle = categoryNameToHandle(categoryName);

  switch (categoryHandle) {
    case 'smartphones':
      return '/collections/smartphones';
    case 'smartwatches':
      return '/collections/smartwatches';
    case 'tablets':
      return '/collections/tablets';
    case 'laptops':
      return '/collections/laptops';
    default:
      return `/collections/${categoryHandle}/${categoryPk}`;
  }
};

export function notNull<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}
